module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study-nav",
    on: {
      "mouseover": _vm.mouseover,
      "mouseout": _vm.mouseout
    }
  }, [_c('a', {
    ref: "link",
    staticClass: "case-study__link",
    attrs: {
      "to": _vm.to
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClick($event)
      }
    }
  }, [_c('span', {
    ref: "title",
    staticClass: "case-study__title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n      "), _c('div', {
    ref: "hoverLine",
    staticClass: "case-study__hover"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a38bdd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CaseStudy.vue
// module id = 167
// module chunks = 1